import React from 'react';
import { useCreateAgreementContext } from './context';
import MainLayoutIgniter from '../../common/mainLayout';
import {
	StyledDraftSubtitle,
	StyledPaginationButtonWrapper,
	StyledStepFormHeader,
	StyledStepFormWrapper,
	StyledStepsHeader,
	StyledStepWrapper
} from './styles';
import { Heading2, Heading3, Text4 } from '../../../../libs/uiKit/globalStyledComponents';
import { ArrowIcon } from '../../../../icons/ui/Arrow';
import Button from '../../../../libs/uiKit/button';
import DeclarationModal from "../widgets/declarationModal";
import FinalWarningModal from "../widgets/FinalWarningModal";
import {PRODUCT_FLAT, PRODUCT_MORTGAGE} from "../../../../libs/utils/staticData";

const CreateAgreementUi: React.FC<{ children: React.ReactNode }> = props => {
	const { children } = props;
	const {
		isEdit,
		goBackHandler,
		currentStepNumber,
		currentStepTitle,
		isShowNextStep,
		isShowPrevStep,
		isDisabledPrevStep,
		isDisabledNextStep,
		prevStepHandler,
		nextStepHandler,
		onFormSubmit,
		isLoading,
		isLastStep,
		closeCreateModalHandler,
		closeDeclarationModalHandler,
		createModalIsOpen,
		declarationModalIsOpen,
		agreementId,
		calcForm,
		isDeclarationAvailable,
		createAgreementAvaiable,
		expressMode,
		addendumMode,
		isFieldsDisabled,
		productId,
		setLastButton,
		draftSubtitle,
	} = useCreateAgreementContext();

	const showFlatRecalc = productId === PRODUCT_FLAT && isLastStep;

	return (
		<MainLayoutIgniter>
			<form onSubmit={onFormSubmit}>
				<StyledStepWrapper>
					<StyledStepsHeader>
						{!isEdit && productId === PRODUCT_MORTGAGE && (
							<Button onClick={goBackHandler} appearance='text' iconBefore={<ArrowIcon direction='left' />}>
								Предрасчет
							</Button>
						)}
						{productId === PRODUCT_MORTGAGE &&
							<Heading2>{addendumMode ? 'Дострахование рисков' : (isEdit ? 'Изменение заявки на страхование' : 'Создание заявки на страхование')}</Heading2>
						}
						{productId === PRODUCT_FLAT && <>
							<Heading2>Оформление</Heading2>
							<StyledDraftSubtitle>{draftSubtitle}</StyledDraftSubtitle>
							</>
						}
					</StyledStepsHeader>

					<StyledStepFormWrapper>
						<StyledStepFormHeader>
							<Heading3>{currentStepTitle}</Heading3>
							<Text4>Шаг {currentStepNumber}</Text4>
						</StyledStepFormHeader>
						{children}
					</StyledStepFormWrapper>

					<StyledPaginationButtonWrapper style={{gridTemplateColumns: productId === PRODUCT_FLAT ? '1fr' : '1fr 1fr'}}>
						{isShowPrevStep && (
							<Button isDisabled={isDisabledPrevStep} appearance='transparent' isLoading={isLoading} onClick={(event) => prevStepHandler(event, !isFieldsDisabled)}>
								Предыдущий шаг
							</Button>
						)}
						{!isShowPrevStep && !showFlatRecalc && <div/>}

						{isShowNextStep && !(isFieldsDisabled && !isLastStep) && (
							<Button isDisabled={isDisabledNextStep} type='submit' appearance='filled' isLoading={isLoading} onClick={() => setLastButton('next')}>
								{isLastStep ? (addendumMode ? 'Дострахование' : ((createAgreementAvaiable || productId === PRODUCT_FLAT) ? 'Создать договор' : 'Создать заявку')) : 'Следующий шаг'}
							</Button>
						)}
						{isShowNextStep && isFieldsDisabled && !isLastStep && (
							<Button isDisabled={isDisabledNextStep} type='button' appearance='filled' isLoading={isLoading} onClick={nextStepHandler}>
								Следующий шаг
							</Button>
						)}
					</StyledPaginationButtonWrapper>
				</StyledStepWrapper>
				<FinalWarningModal isOpen={createModalIsOpen} onClose={closeCreateModalHandler} isLoading={isLoading} createAgreement={createAgreementAvaiable}/>
				<DeclarationModal
					onClose={closeDeclarationModalHandler}
					isOpen={declarationModalIsOpen}
					agreementId={agreementId}
					personId={calcForm?.policyholder?.isn}
					phone={calcForm?.policyholder?.phone}
					agreementMode={false}
					showDeclaration={isDeclarationAvailable}
				/>
			</form>
		</MainLayoutIgniter>
	);
};

export default React.memo(CreateAgreementUi);
